// Client-side app_id utilities (không sử dụng next/headers)

// Generate UUID for app_id
export function generateUUID(): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;

    return v.toString(16);
  });
}

// Check if app_id is expired (older than 30 minutes)
export function isAppIdExpired(timestamp: number): boolean {
  const now = Date.now();
  const thirtyMinutes = 30 * 60 * 1000; // 30 minutes in milliseconds

  return now - timestamp > thirtyMinutes;
}

// Client-side: Get or create app_id from cookies
export function getOrCreateAppIdFromCookiesClient(): string {
  const APP_ID_KEY = 'app_id';
  const APP_ID_TIMESTAMP_KEY = 'app_id_timestamp';

  try {
    // Chỉ tối ưu: đọc document.cookie 1 lần thay vì 2 lần
    const cookies = document.cookie;

    const getCookie = (name: string): string | null => {
      const value = `; ${cookies}`;
      const parts = value.split(`; ${name}=`);

      if (parts.length === 2) {
        return parts.pop()?.split(';').shift() || null;
      }

      return null;
    };

    const existingAppId = getCookie(APP_ID_KEY);
    const existingTimestamp = getCookie(APP_ID_TIMESTAMP_KEY);

    // Giữ nguyên logic cũ
    if (!existingAppId || !existingTimestamp) {
      const newAppId = generateUUID();
      const timestamp = Date.now();

      document.cookie = `${APP_ID_KEY}=${newAppId}; max-age=${30 * 60}; path=/; samesite=lax`;
      document.cookie = `${APP_ID_TIMESTAMP_KEY}=${timestamp}; max-age=${30 * 60}; path=/; samesite=lax`;

      return newAppId;
    }

    // Giữ nguyên parseInt
    const timestamp = parseInt(existingTimestamp);

    if (isAppIdExpired(timestamp)) {
      // Giữ nguyên việc remove cookie
      document.cookie = `${APP_ID_KEY}=; max-age=0; path=/`;
      document.cookie = `${APP_ID_TIMESTAMP_KEY}=; max-age=0; path=/`;

      const newAppId = generateUUID();
      const newTimestamp = Date.now();

      document.cookie = `${APP_ID_KEY}=${newAppId}; max-age=${30 * 60}; path=/; samesite=lax`;
      document.cookie = `${APP_ID_TIMESTAMP_KEY}=${newTimestamp}; max-age=${30 * 60}; path=/; samesite=lax`;

      return newAppId;
    }

    return existingAppId;
  } catch {
    return generateUUID();
  }
}
